import React from 'react';

/**
 * Kanonische Überschriften der eingeloggten App (Poppins, Token-Farben).
 *
 * Ersetzt die bisher konkurrierenden Muster
 * (`text-foreground`, `text-foreground`,
 * Gradient-Clip-Titel) durch genau einen Stil pro Rolle.
 *
 * Für Marketing-/Brand-Headlines (Bungee mit pinkem Versatz-Schatten)
 * stattdessen <DisplayHeading> nutzen.
 *
 * Die Köpfe der Hauptseiten ("ENTDECKEN", "LERNSESSIONS") laufen weiterhin über
 * `PageTitle` — sie bekommen die Display-Schrift seit August 2026 als KLASSE
 * dazu (`.display-title`, gesetzt von ui/SectionHeader.jsx). Farbe, Gewicht und
 * Größenskala bleiben damit an einer Stelle.
 */

export const PageTitle = ({ as: Tag = 'h1', className = '', children, ...rest }) => (
  <Tag className={`text-2xl sm:text-3xl font-bold text-foreground tracking-tight ${className}`} {...rest}>
    {children}
  </Tag>
);

export const SectionTitle = ({ as: Tag = 'h2', className = '', children, ...rest }) => (
  <Tag className={`text-lg font-semibold text-foreground ${className}`} {...rest}>
    {children}
  </Tag>
);

export default PageTitle;
